export default __webpack_public_path__ + "static/media/5.f57751cc.jpg";